import Vue from 'vue'
import { translate, DateFactory } from 'rhg-vue-common'
import { language } from '@/infrastructure/Configuration'
import { getPageLanguage } from '@/infrastructure/Utils'

export const toPoints = function (points) {
  if (!points) return null
  return translate('hdNumPoints', points, points.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
}

export const longDate = function (date, pattern = DateFactory.DatePatterns.GENERAL) {
  if (!date) return null

  if (language.includes('zh')) {
    return DateFactory.formatDate(date, DateFactory.DatePatterns.CHINESE)
  }

  const formattedDate = DateFactory.formatWithLocaleDate(date, pattern, language.split('-')[0])
  return formattedDate
    .toLowerCase()
    .replace(/\./g, '')
    .split(' ')
    .map(word => !language.includes('uk') ? `${word.charAt(0).toUpperCase()}${word.slice(1)}` : `${word}`)
    .join(' ')
}

export const formatDateNoYear = (dates) => {
  const starDateAndEndDareAreSame = DateFactory.getYear(dates.start) === DateFactory.getYear(dates.end)
  const formatStartDate = starDateAndEndDareAreSame ? longDate(dates.start, 'DD MMM') : longDate(dates.start)

  return `${formatStartDate} - ${longDate(dates.end)}`
}

export const formatDateMonth = (dates) => {
  const locale = getPageLanguage() || 'en-us'
  const format = { month: 'short', day: 'numeric', weekday: 'short' }
  const formatEndDate = new Date(dates.end).toLocaleDateString(locale, format).replace(',', '').replace(/^(\w{3})\s(\w{3})\s(\d{1,2})/, '$1 $3 $2')
  const formatStartDate = new Date(dates.start).toLocaleDateString(locale, format).replace(',', '').replace(/^(\w{3})\s(\w{3})\s(\d{1,2})/, '$1 $3 $2')
  return `${formatStartDate} - ${formatEndDate}`
}

export const toDate = function (date) {
  if (!date) {
    return null
  }

  if (language.includes('zh')) {
    return DateFactory.formatDate(date, DateFactory.DatePatterns.CHINESE)
  }

  const formattedDate = DateFactory.formatWithLocaleDate(date, DateFactory.DatePatterns.GENERAL, language.split('-')[0])

  return formattedDate
    .toLowerCase()
    .replace(/\./g, '')
    .split(' ')
    .map(word => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
    .join(' ')
}

export const toTime = function (stringNonAMPM) {
  if (!stringNonAMPM || stringNonAMPM.length < 4 || stringNonAMPM.indexOf(':') === -1) {
    return stringNonAMPM
  }

  const splitted = stringNonAMPM.split(':')
  if (splitted.length !== 2 || isNaN(parseInt(splitted[0])) || isNaN(parseInt(splitted[1]))) {
    return stringNonAMPM
  }

  const h = parseInt(splitted[0])
  const m = parseInt(splitted[1])

  let hour = 12
  if (h % 12) {
    hour = language !== 'tr' ? h % 12 : h % 24
  }

  const minute = m < 10 ? '0' + m : m
  if (language === 'tr') {
    return hour + ':' + minute
  }

  const ampm = h >= 12 ? 'PM' : 'AM'

  return hour + ':' + minute + ' ' + ampm
}

Vue.filter('toPoints', toPoints)
Vue.filter('toDate', toDate)
Vue.filter('toTime', toTime)
Vue.filter('longDate', longDate)
Vue.filter('formatDateNoYear', formatDateNoYear)
